import _createClass from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import * as globalImportUrl from 'url';
export { globalImportUrl };
export var Configuration = /*#__PURE__*/_createClass(
/**
 * parameter for apiKey security
 * @param name security name
 * @memberof Configuration
 */

/**
 * parameter for basic security
 *
 * @type {string}
 * @memberof Configuration
 */

/**
 * parameter for basic security
 *
 * @type {string}
 * @memberof Configuration
 */

/**
 * parameter for oauth2 security
 * @param name security name
 * @param scopes oauth2 scope
 * @memberof Configuration
 */

/**
 * override base path
 *
 * @type {string}
 * @memberof Configuration
 */

/**
 * base options for axios calls
 *
 * @type {any}
 * @memberof Configuration
 */
function Configuration() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Configuration);

  _defineProperty(this, "apiKey", void 0);

  _defineProperty(this, "username", void 0);

  _defineProperty(this, "password", void 0);

  _defineProperty(this, "accessToken", void 0);

  _defineProperty(this, "basePath", void 0);

  _defineProperty(this, "baseOptions", void 0);

  this.apiKey = param.apiKey;
  this.username = param.username;
  this.password = param.password;
  this.accessToken = param.accessToken;
  this.basePath = param.basePath;
  this.baseOptions = param.baseOptions;
});
/**
 *
 * @export
 * @class BaseAPI
 */

export var BaseAPI = /*#__PURE__*/_createClass(function BaseAPI(axios, configuration) {
  _classCallCheck(this, BaseAPI);

  this.axios = axios;

  _defineProperty(this, "configuration", void 0);

  if (configuration) {
    this.configuration = configuration;
  }
});
;